import React, { useEffect } from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import MainSlider from "./MainSlider";
import FaqSection from "./FaqSection";
import ContactSection from "./ContactSection";
import VisitorCounter from "../Components/VisitorCounter";
import Chatbot from "../Components/Chatbot";
import { useDonation } from "../Components/DonationContext";
import "./WhyJoinUs.css";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaCheck,
  FaHandHoldingHeart,
  FaHeart,
  FaLeaf,
} from "react-icons/fa";
export default function Home() {
  const { openDonation } = useDonation();

  useEffect(() => {
    openDonation();
  }, []);

  const CHECKLIST_LEFT = ["Education for All", "Health & Nutrition", "Skill Development"];
  const CHECKLIST_RIGHT = ["Community Empowerment", "Clean Water & Sanitation", "Brighter Future"];

  return (
    <>
      {/* <div className="loader js-preloader">
        <div></div>
        <div></div>
        <div></div>
      </div> */}

      <Header />

      {/* Visitor Counter - Left Side */}
      <VisitorCounter />

      {/* Chatbot - Right Side */}
      <Chatbot />

        <div className="page-wrapper">
          <MainSlider />

          {/*Start  2nd section */}

          <div>
            <div className="about-one">
              <div className="shape2 float-bob-y">
                <img
                  src="assets/images/shapes/about-v1-shape2.png"
                  alt=""
                  style={{ filter: "hue-rotate(90deg)" }}
                />
              </div>
              <div className="container">
                <div className="row">
                  {/*Start About One Img*/}
                  <div
                    className="col-xl-6 wow fadeInLeft"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="about-one__img">
                      <div className="shape1">
                        <img
                          src="assets/images/shapes/about-v1-shape1.png"
                          alt=""
                        />
                      </div>
                      <div className="about-one__img-inner">
                        <div className="about-one__img1">
                          <div className="inner">
                            <img src="assets/images/about/banner2.Jpg" alt="" />
                          </div>
                        </div>
                        <div className="about-one__img2">
                          <img
                            src="assets/images/about/about-v1-img2.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="about-one__img-content">
                        <div className="about-one__img-content-inner">
                          <h2>India's 1.17M+ Children Need School</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*End About One Img*/}

                  {/*Start About One Content*/}
                  <div
                    className="col-xl-6 wow fadeInRight"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="about-one__content">
                      <div className="sec-title sec-title-animation animation-style2">
                        <div className="sec-title__tagline">
                          <div className="left-line" />
                          <div className="text">
                            <h4>Together for change</h4>
                          </div>
                        </div>
                        <h2 className="sec-title__title title-animation">
                          Help the Underprivileged with your priceless Contributions
                        </h2>
                      </div>
                      <div className="about-one__content-text">
                        <p>
                          We create change that truly matters. Together, we can turn compassion into action and uplift lives in need. Every contribution you make adds hope, dignity, and opportunity to someone’s journey.
                        </p>
                      </div>
                      <div className="about-one__highlight-cards">
                        <div className="about-one__highlight-card">
                          <span>1,500+</span>
                          <h3>Children Supported</h3>
                          <p>Providing education, wellness, and joyful learning experiences across communities.</p>
                        </div>
                        <div className="about-one__highlight-card">
                          <span>75+</span>
                          <h3>Community Events</h3>
                          <p>Local campaigns and programs that build trust, awareness, and lasting support.</p>
                        </div>
                        <div className="about-one__highlight-card">
                          <span>100%</span>
                          <h3>Transparent Giving</h3>
                          <p>Every donation is tracked with care and used to create measurable, meaningful impact.</p>
                        </div>
                      </div>
                      <div className="about-one__tab tab-box">
                        <div className="tabs-content tabs-content-box">
                          {/*Start Single Tab Content*/}
                          <div className="tab" id="cause">
                            <div className="about-one__single-tab">
                              <div className="about-one__single-tab-inner">
                                <div className="about-one__single-tab-text1">
                                  <div className="icon-box">
                                    <span className="icon-checked" />
                                  </div>
                                  
                                </div>
                                <div className="about-one__single-tab-text2">
                                  <ul className="row">
                                    <li className="col-xl-6 col-lg-6 col-md-6 about-one__single-tab-text2-single">
                                      <div className="about-one__single-tab-text2-single-inner">
                                        <div className="icon-box">
                                          <span className="icon-solidarity" />
                                        </div>
                                        <div className="text-box">
                                          <h3>Our Approach</h3>
                                          <p>
                                            We identify real community needs, channel resources transparently, and ensure every donation brings measurable change.
                                          </p>
                                        </div>
                                      </div>
                                    </li>
                                    <li className="col-xl-6 col-lg-6 col-md-6 about-one__single-tab-text2-single">
                                      <div className="about-one__single-tab-text2-single-inner">
                                        <div className="icon-box">
                                          <span className="icon-zakat" />
                                        </div>
                                        <div className="text-box">
                                          <h3>Our Impact</h3>
                                          <p>
                                            Every contribution supports education, healthcare, and rehabilitation programs for underprivileged children and families.
                                          </p>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*End Single Tab Content*/}
                        </div>
                      </div>
                      <div className="about-one__content-bottom">
                        
                        <div className="contact-info">
                          <div className="icon-box">
                            <span className="icon-telephone" />
                          </div>
                          <div className="content-box">
                            <p>Call us any time:</p>
                            <h4>
                              <a href="tel:1234567890">+91-674-2548306</a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*Start Services One*/}
          <section id="os" className="services-one">
            <div className="shape2 float-bob-y">
              <img src="assets/images/shapes/services-v1-shape2.png" alt="" />
            </div>
              <div className="container">
              <div className="sec-title text-center sec-title-animation animation-style1">
                <div className="sec-title__tagline center">
                  <div className="left-line" />
                  <div className="text">
                    <h4>What We Do</h4>
                  </div>
                  <div className="right-line" />
                </div>
                <h2 className="sec-title__title title-animation">
                  Turning Compassion Into Lasting Impact
                </h2>
              </div>
              <div className="row">
                {/*First row: show 3 cards (3 columns on xl)*/}
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInLeft"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                <div className="services-one__single text-center">
                    <div className="shape1">
                      <img
                        src="assets/images/shapes/services-v1-shape1.png"
                        alt=""
                      />
                    </div>
                    <div className="services-one__single-icon">
                      <span className="icon-mortarboard" />
                    </div>
                    <h2 className="">
                      Education
                    </h2>
                    <p>
                      Education is the light that dispels generations of darkness. Therefore, we nurture young minds from underprivileged communities by providing access to education and equality. 
                    </p>
                </div>
                </div>

                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInRight"
                  data-wow-delay="100ms"
                  data-wow-duration="1500ms"
                >
                  <div className="services-one__single text-center">
                    <div className="shape1">
                      <img
                        src="assets/images/shapes/services-v1-shape1.png"
                        alt=""
                      />
                    </div>
                    <div className="services-one__single-icon">
                      <span className="icon-supplies" />
                    </div>
                    <h2>Good Governance</h2>
                    <p>
                     Good governance begins at the grassroots level. We work closely with communities and local institutions to strengthen transparency, accountability.
                    </p>
                  </div>
                </div>

                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInLeft"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="services-one__single text-center">
                    <div className="shape1">
                      <img
                        src="assets/images/shapes/services-v1-shape1.png"
                        alt=""
                      />
                    </div>
                    <div className="services-one__single-icon">
                      <span className="icon-first-aid-kit" />
                    </div>
                    <h2>Health</h2>
                    <p>
                      Health is every person’s right, not a privilege. At Vikash Foundation, we provide affordable care, preventive awareness, and support to families in rural and marginalized.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center mt-4">
                {/*Second row: show 2 centered cards*/}
                <div
                  className="col-xl-6 col-lg-6 col-md-6 wow fadeInRight"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="services-one__single text-center">
                    <div className="shape1">
                      <img
                        src="assets/images/shapes/services-v1-shape1.png"
                        alt=""
                      />
                    </div>
                    <div className="services-one__single-icon">
                      <span className="icon-team" />
                    </div>
                    <h2>Disability</h2>
                    <p>
                      Disability does not define limits, it defines resilience. Through our focused rehabilitation programs, we strive to remove social barriers, provide therapy and value every person’s.
                    </p>
                  </div>
                </div>
                <div
                  className="col-xl-6 col-lg-6 col-md-6 wow fadeInRight"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="services-one__single text-center">
                    <div className="shape1">
                      <img
                        src="assets/images/shapes/services-v1-shape1.png"
                        alt=""
                      />
                    </div>
                    <div className="services-one__single-icon">
                      <span className="icon-team" />
                    </div>
                    <h2>Sanitation</h2>
                    <p>
                      Sanitation is a foundation of dignity. We promote clean habits, safe sanitation systems, and community-driven cleanliness drives that protect both health.
                    </p>
                  </div>
                </div>
            </div>
            </div>
          </section>
          {/*End Services One*/}

          {/*Start Why Choose One*/}
          <section className="why-choose-one">
            <div
              className="why-choose-one__pattern"
              style={{
                backgroundImage:
                  "url(assets/images/pattern/why-choose-v1-pattern.jpg)",
              }}
            />
            <div className="shape1">
              <img
                src="assets/images/shapes/why-choose-v1-shape1.png"
                alt=""
                style={{ filter: "hue-rotate(90deg)" }}
              />
            </div>
            <div className="shape2">
              <img
                src="assets/images/shapes/why-choose-v1-shape2.png"
                alt=""
                style={{ filter: "hue-rotate(90deg)" }}
              />
            </div>
            <div className="container">
              <div className="row">
                {/*Start Why Choose One Content*/}
                <div className="col-xl-6">
                  <div className="why-choose-one__content">
                    <div className="sec-title sec-title-animation animation-style2">
                      <div className="sec-title__tagline">
                        <div className="left-line" />
                        <div className="text">
                          <h4>What we have achieved</h4>
                        </div>
                      </div>
                      <h2 className="sec-title__title title-animation">
                        Our Journey From Vision to Victory
                      </h2>
                    </div>
                    <div className="why-choose-one__content-text1">
                      <p>
                        From a small initiative rooted in compassion to a movement of inclusion and empowerment, Vikash Foundation’s journey has been one of purpose, persistence, and hope. Guided by vision and strengthened by our supporters and community trust, we’ve turned countless challenges into stories of change.
                      </p>
                    </div>

                    <div className="why-choose-one__content-text3">
                        <ul className="row">
                        <li className="col-xl-6 col-lg-6 col-md-6 why-choose-one__content-text3-single">
                          <motion.div
                            className="why-choose-one__content-text3-single-inner glass-card"
                            tabIndex={0}
                            role="button"
                            aria-label="Start Your Giving Journey"
                            whileHover={{ y: -10, scale: 1.05 }}
                            whileTap={{ scale: 0.98 }}
                            transition={{ duration: 0.4 }}
                          >
                            <div className="glass-card__accent" />
                            <div className="text-box">
                              <h3>Start Your Giving Journey</h3>
                              <p>
                                Support education, nutrition, and brighter futures for children from vulnerable communities.
                              </p>
                            </div>
                          </motion.div>
                        </li>

                        <li className="col-xl-6 col-lg-6 col-md-6 why-choose-one__content-text3-single">
                          <motion.div
                            className="why-choose-one__content-text3-single-inner glass-card"
                            tabIndex={0}
                            role="button"
                            aria-label="Empower Families with Hope"
                            whileHover={{ y: -10, scale: 1.05 }}
                            whileTap={{ scale: 0.98 }}
                            transition={{ duration: 0.4 }}
                          >
                            <div className="glass-card__accent" />
                            <div className="text-box">
                              <h3>Empower Families with Hope</h3>
                              <p>
                                Every gift creates safe homes, community support, and lasting change for underserved families.
                              </p>
                            </div>
                          </motion.div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/*End Why Choose One Content*/}

                {/*Start Why Choose One Img*/}
                <div className="col-xl-6">
                  <div className="why-choose-one__img clearfix">
                    <div className="why-choose-one__img1">
                      <div className="inner">
                        <img
                          src="assets/images/resources/3boy.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="why-choose-one__img2">
                      <img
                        src="assets/images/resources/2bg.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                {/*End Why Choose One Img*/}
              </div>
            </div>
          </section>
          {/*End Why Choose One*/}

          {/*Start Approch One*/}
           <section className="wju">
      {/* Decorative corner illustrations */}
      <FaHandHoldingHeart className="wju__hand wju__hand--left" aria-hidden="true" />
      <FaHandHoldingHeart className="wju__hand wju__hand--right" aria-hidden="true" />
      <span className="wju__leafCluster wju__leafCluster--bl" aria-hidden="true">
        <FaLeaf />
        <FaLeaf />
        <FaLeaf />
      </span>
      <span className="wju__leafCluster wju__leafCluster--br" aria-hidden="true">
        <FaLeaf />
        <FaLeaf />
      </span>
 
      <div className="container">
        <motion.div
          className="wju__header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
        >
          <div className="wju__tagline">
            <span className="wju__tagline-line" />
            <span className="wju__tagline-text">
              <FaHeart /> Why Join Us <FaHeart />
            </span>
            <span className="wju__tagline-line" />
          </div>
 
          <h2 className="wju__title">
            Reasons to
            <br />
            <span>Support Our Mission</span>
          </h2>
 
          <div className="wju__miniDivider">
            <span />
            <FaHeart />
            <span />
          </div>
 
          <p className="wju__subtitle">
            Your support helps us bring lasting change in the lives of those
            who need it the most.
          </p>
        </motion.div>
 
        <motion.div
          className="wju__card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
        >
          <div className="wju__cardContent">
            <span className="wju__cardIcon">
              <FaHandHoldingHeart />
            </span>
 
            <h3 className="wju__cardTitle">Inspiring Hope with Generous Acts</h3>
            <span className="wju__cardUnderline" />
 
            <p className="wju__cardText">
              Vikash is committed to creating sustainable change by providing
              access to education, and holistic opportunities, fostering
              dignity and a promising future.
            </p>
 
            <div className="wju__checklist">
              <ul>
                {CHECKLIST_LEFT.map((item) => (
                  <li key={item}>
                    <span className="wju__checkIcon">
                      <FaCheck />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <ul>
                {CHECKLIST_RIGHT.map((item) => (
                  <li key={item}>
                    <span className="wju__checkIcon">
                      <FaCheck />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
 
            <button type="button" className="wju__donateBtn" onClick={openDonation}>
              <span className="wju__donateBtn-icon">
                <FaHeart />
              </span>
              Donate Now
              <span className="wju__donateBtn-arrow">
                <FaArrowRight />
              </span>
            </button>
          </div>
 
          <div className="wju__imageWrap">
            <img src="/assets/images/resources/sittingboy.png" alt="Child we support" />
          </div>
        </motion.div>
      </div>
    </section>
          {/*End Approch One*/}

          {/* testimonial */}
          <section className="testimonial-one">
            <div
              className="testimonial-one__pattern"
              style={{
                backgroundImage:
                  "url('/assets/images/pattern/testimonial-v1-pattern.jpg')",
              }}
            ></div>

            <div className="container">
              <div className="testimonial-one__header text-center">
                <div className="sec-title sec-title-animation animation-style2">
                  <div className="sec-title__tagline center">
                    <div className="left-line" />
                    <div className="text">
                      <h4>Testimonials</h4>
                    </div>
                    <div className="right-line" />
                  </div>
                  <h2 className="sec-title__title title-animation">
                    What They <span>Say</span>
                  </h2>
                </div>
                <p className="testimonial-one__subtitle">
                  Hear from the people and partners who have been part of our journey.
                  <br />
                  Their words reflect the impact we create together.
                </p>
                <div className="testimonial-one__divider" aria-hidden="true">
                  <span />
                  <i className="icon-leaf" />
                  <span />
                </div>
              </div>

              <div className="testimonial-one__cards row gx-4 gy-4 justify-content-center">
                <div className="col-lg-4 col-md-6">
                  <div className="testimonial-one__card">
                    <div className="testimonial-one__card-top d-flex align-items-start justify-content-between">
                      <div className="testimonial-one__quote-icon">
                        <span className="icon-ux"></span>
                      </div>
                      <div className="testimonial-one__rating d-flex align-items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className="icon-star"></i>
                        ))}
                      </div>
                    </div>
                    <p>
                      "I’ve seen real change in our community because of Vikash.
                      Their dedication truly inspires everyone around them."
                    </p>
                    <div className="testimonial-one__author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="/assets/images/testimonial/ts1.png"
                          alt="Mr Stalin Rout"
                        />
                      </div>
                      <div className="author-meta">
                        <h3>Mr Stalin Rout</h3>
                        <p>Community Partner</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="testimonial-one__card">
                    <div className="testimonial-one__card-top d-flex align-items-start justify-content-between">
                      <div className="testimonial-one__quote-icon">
                        <span className="icon-ux"></span>
                      </div>
                      <div className="testimonial-one__rating d-flex align-items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className="icon-star"></i>
                        ))}
                      </div>
                    </div>
                    <p>
                      "Volunteering here showed me that lasting progress begins by
                      listening. Every programme puts people and dignity first."
                    </p>
                    <div className="testimonial-one__author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="/assets/images/testimonial/ts2.png"
                          alt="Ananya Mishra"
                        />
                      </div>
                      <div className="author-meta">
                        <h3>Ananya Mishra</h3>
                        <p>Dr, Bhubaneswar</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="testimonial-one__card">
                    <div className="testimonial-one__card-top d-flex align-items-start justify-content-between">
                      <div className="testimonial-one__quote-icon">
                        <span className="icon-ux"></span>
                      </div>
                      <div className="testimonial-one__rating d-flex align-items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className="icon-star"></i>
                        ))}
                      </div>
                    </div>
                    <p>
                      "Their premium care, thoughtful design and unwavering commitment
                      make every project feel deeply meaningful."
                    </p>
                    <div className="testimonial-one__author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="/assets/images/testimonial/ts3.png"
                          alt="Sanjeev Kumar"
                        />
                      </div>
                      <div className="author-meta">
                        <h3>Sanjeev Kumar</h3>
                        <p>Program Mentor</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="testimonial-one__cta-wrap">
                <span className="testimonial-one__cta-line" />
                <Link to="/volunteer" className="testimonial-one__cta">
                  <span className="icon-leaf" />
                  Be a Part of the Change
                  <span className="icon-diagonal-arrow1" />
                </Link>
                <span className="testimonial-one__cta-line" />
              </div>
            </div>
          </section>

          {/*Start Faq One*/}
          <FaqSection />
          {/*End Faq One*/}

          {/*Start Contact One */}
        
          <ContactSection />
          {/*End Contact One */}

          {/*Start Cause Two*/}
          <section className="cause-two cause-two--three">
            <div className="container">
              <div>
                <h2 className="text-center fw-bold ">Actions</h2>
              </div>
              <div>
                <h2 className="text-center  fw-bold ">
                  View the latest Actions here
                </h2>
              </div>
              <div className="row">
                {/*Start Cause One Single*/}
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="cause-one__single">
                    <div className="cause-one__single-inner">
                      <div className="cause-one__single-img">
                        <img
                          src="assets/images/resources/action1.jpg"
                          alt="People in a meeting"
                        />
                      </div>
                      <div className="cause-one__single-content">
                        <h2>
                          Vikash worked with leprosy-affected persons for their
                          rights since 1986.
                        </h2>
                        <div className="cause-one__single-bottom">
                          <div
                            className="cause-one__single-bottom-pattern"
                            style={{
                              backgroundImage:
                                "url(assets/images/pattern/cause-v1-single-bottom-pattern.jpg)",
                            }}
                          ></div>
                          <div className="cause-one__rised-and-progress">
                            <div className="title-box">
                              <h4>Actions</h4>
                            </div>
                            <div className="progress-box">
                              <div className="inner count-box">
                                <div className="bar">
                                  <div
                                    className="bar-inner count-bar"
                                    style={{ width: "85%" }} // <-- FIX: Changed to inline style
                                  >
                                    <div className="count-text">85%</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="btn-box">
                            <Link to="/leprosy" className="thm-btn">
                              Read More{" "}
                              <span className="icon-diagonal-arrow1" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*End Cause One Single*/}

                {/*Start Cause One Single*/}
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInDown"
                  data-wow-delay=".3s"
                >
                  <div className="cause-one__single">
                    <div className="cause-one__single-inner">
                      <div className="cause-one__single-img">
                        <img
                          src="assets/images/resources/action2.jpg"
                          alt="Community gathering"
                        />
                      </div>
                      <div className="cause-one__single-content">
                        <h2>
                          Vikash worked with SUH persons for their right since
                          2016
                        </h2>
                        <div className="cause-one__single-bottom">
                          <div
                            className="cause-one__single-bottom-pattern"
                            style={{
                              backgroundImage:
                                "url(assets/images/pattern/cause-v1-single-bottom-pattern.jpg)",
                            }}
                          ></div>
                          <div className="cause-one__rised-and-progress">
                            <div className="title-box">
                              <h4>Actions</h4>
                            </div>
                            <div className="progress-box">
                              <div className="inner count-box">
                                <div className="bar">
                                  <div
                                    className="bar-inner count-bar"
                                    style={{ width: "75%" }} // <-- FIX: Changed to inline style
                                  >
                                    <div className="count-text">75%</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="btn-box">
                            <Link to="/leprosy1" className="thm-btn">
                              Read more{" "}
                              <span className="icon-diagonal-arrow1" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*End Cause One Single*/}

                {/*Start Cause One Single*/}
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="cause-one__single">
                    <div className="cause-one__single-inner">
                      <div className="cause-one__single-img">
                        <img
                          src="assets/images/resources/action3.jpg"
                          alt="Children in a classroom"
                        />
                      </div>
                      <div className="cause-one__single-content">
                        <h2>
                          Vikash facilitates peoples’ initiatives to ensure
                          quality and equitable education for all.
                        </h2>
                        <div className="cause-one__single-bottom">
                          <div
                            className="cause-one__single-bottom-pattern"
                            style={{
                              backgroundImage:
                                "url(assets/images/pattern/cause-v1-single-bottom-pattern.jpg)",
                            }}
                          ></div>
                          <div className="cause-one__rised-and-progress">
                            <div className="title-box">
                              <h4>Actions</h4>
                            </div>
                            <div className="progress-box">
                              <div className="inner count-box">
                                <div className="bar">
                                  <div
                                    className="bar-inner count-bar"
                                    style={{ width: "65%" }} // <-- FIX: Changed to inline style
                                  >
                                    <div className="count-text">65%</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="btn-box">
                            <Link to="/ens" className="thm-btn">
                              Read more{" "}
                              <span className="icon-diagonal-arrow1" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*End Cause One Single*/}
              </div>
            </div>
          </section>
          {/*End Cause Two*/}
        </div>

      <Footer />

      <a href="#top" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
}
